// extracted by mini-css-extract-plugin
export default {"videoEmbed":"_2SVjn","player":"WTvL-","thumbnail":"_3K_P1","overlay":"_3V6jk","button":"_33PdZ","arrow":"_2fJIL","icon":"_24Urt"};